/**
 * @Author: Florian Merel <florian>
 * @Date:   31-Aug-2021
 * @Email:  florian.merel@prokov.com
 * @Project: ComEditServer
 * @Filename: ticketsV2Tickets.js
 * @Last modified by:   florian
 * @Last modified time: 01-Sep-2021
 */

import axios from "axios";
import server from "../../server.js";
import servicesError from "../../ServicesError.js";
import Vue from "vue";
import store from "@/store";

const state = {
  loading: false,
  error: {},
  data: null,
};

const getters = {
  getData(state) {
    return state.data;
  },
};

const mutations = {
  setError(context, error) {
    context.data = null;
    context.error = error;
  },

  setLoading(context, loading) {
    context.loading = loading;
  },

  setData(context, data) {
    context.data = data;
  },
};

const actions = {
  async updateTicket(context, params) {
    context.commit("setLoading", true);
    try {
      let res = await axios({
        method: "POST",
        url:
          server.url +
          server.urls.ticketV2Tickets +
          "/" +
          params.url +
          "/update",
        data: params.data,
        headers: server.getHeader(),
      });
      context.commit("setData", res.data);
      return res.data;
    } catch (error) {
      if (servicesError.isConnection(error)) {
        servicesError.analyseErrorService(error.response.data);
        context.commit("setError", error.response.data);
      }
    }
    context.commit("setLoading", false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
